import React from "react";
import Layout from "../components/Layout";
import SidebarLayout from "../components/Sidebar";
import ContactsPage from "../components/ContactsPage";

const MyContacts = () => {
  return (
    <Layout>
      <SidebarLayout>
        <ContactsPage />
      </SidebarLayout>
    </Layout>
  );
};

export default MyContacts;
